var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { FC, memo, useCallback, useEffect, useRef, useState } from "react";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import { Endpoints, TFile } from "@brg/api";
import styled from "styled-components";
import { Colors, FlexBox } from "@brg/ui";
import useLocalization from "../../../../../hooks/useLocalization";
import { MoveIcon } from "../../assets/MoveIcon";
import { DeleteCloseIcon } from "../../assets/DeleteCloseIcon";
import { ImageAddButton, ImagesContentContainer } from "../../styles";
import { SpinnerIcon } from "../../assets/Spinner";
import useUploadValidator, { uploadValidator } from "../../../../../hooks/useUploadValidator";
import { useUppyLoader } from "./uppyLoader";
var SortableImageWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 140px;\n  margin: 0 8px 8px 0;\n  flex-shrink: 0;\n  position: relative;\n  max-width: fit-content;\n  img {\n    user-select: none;\n    object-fit: contain;\n  }\n"], ["\n  height: 140px;\n  margin: 0 8px 8px 0;\n  flex-shrink: 0;\n  position: relative;\n  max-width: fit-content;\n  img {\n    user-select: none;\n    object-fit: contain;\n  }\n"])));
var NegativeMarginContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 -8px -8px 0;\n  position: relative;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 -8px -8px 0;\n  position: relative;\n"])));
var ListWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: 8px;\n  position: relative;\n"], ["\n  margin-bottom: 8px;\n  position: relative;\n"])));
var ButtonWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  position: relative;\n\n  input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    z-index: 1;\n    opacity: 0;\n    cursor: pointer;\n  }\n"], ["\n  width: 100%;\n  position: relative;\n\n  input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    z-index: 1;\n    opacity: 0;\n    cursor: pointer;\n  }\n"])));
var ControlButtonsWrapper = styled(FlexBox)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  justify-content: space-between;\n  padding: 4px;\n"], ["\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  justify-content: space-between;\n  padding: 4px;\n"])));
var Content = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 100%;\n  min-height: 48px;\n  max-width: 610px;\n"], ["\n  width: 100%;\n  min-height: 48px;\n  max-width: 610px;\n"])));
var LoaderWrapper = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  height: 140px;\n  width: 140px;\n  border: 1px solid ", ";\n  margin: 0 8px 8px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  height: 140px;\n  width: 140px;\n  border: 1px solid ", ";\n  margin: 0 8px 8px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), Colors.galBlack10);
var Loader = function () {
    return (React.createElement(LoaderWrapper, null,
        React.createElement(SpinnerIcon, null)));
};
var DragHandle = SortableHandle(function () { return (React.createElement("span", { tabIndex: 0 },
    React.createElement(MoveIcon, { size: "small" }))); });
var SortableItem = SortableElement(function (_a) {
    var value = _a.value, onRemove = _a.onRemove;
    return (React.createElement(SortableImageWrapper, null,
        React.createElement(ControlButtonsWrapper, null,
            React.createElement(DragHandle, null),
            React.createElement(DeleteCloseIcon, { size: "small", onClick: function (e) {
                    onRemove(value.id, value.name);
                } })),
        React.createElement("img", { src: value.src, style: { width: '100%', height: '100%' /*, objectFit: 'cover' */ }, draggable: "false" })));
});
var SortableList = SortableContainer(function (_a) {
    var items = _a.items, onRemove = _a.onRemove;
    return (React.createElement(ListWrapper, { className: "sortable-container" },
        React.createElement(NegativeMarginContainer, null, items.map(function (value, index) { return (React.createElement(SortableItem, { key: value.id, index: index, value: value, onRemove: onRemove })); }))));
});
var ImageArrayComponent = function (_a) {
    var onChange = _a.onChange, isEditing = _a.isEditing, attachments = _a.attachments, update = _a.update;
    var t = useLocalization().t;
    var _b = useState([]), sortedData = _b[0], setSortedData = _b[1];
    var _c = useState(Date.now()), time = _c[0], setTime = _c[1];
    var _d = useState([]), files = _d[0], setFiles = _d[1];
    // const validator = useUploadValidator();
    var fileRef = useRef();
    useEffect(function () {
        onChange(sortedData === null || sortedData === void 0 ? void 0 : sortedData.map(function (data) {
            var _a;
            return {
                files: [{ fileId: (_a = data === null || data === void 0 ? void 0 : data.id) !== null && _a !== void 0 ? _a : '' }]
            };
        }));
    }, [sortedData]);
    var onUploadComplete = useCallback(function (uploadComplete) {
        if (uploadComplete) {
            setFiles([]);
        }
    }, []);
    var onAddImage = useCallback(function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var newFiles, multipleFilesCheckResult, allowed;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newFiles = Array.from(e.target.files);
                    // @ts-ignore
                    if (fileRef === null || fileRef === void 0 ? void 0 : fileRef.current)
                        fileRef.current.value = '';
                    setTime(Date.now());
                    multipleFilesCheckResult = [];
                    if (!((newFiles === null || newFiles === void 0 ? void 0 : newFiles.length) > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all(newFiles.map(function (img) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, uploadValidator([img])];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); }))];
                case 1:
                    multipleFilesCheckResult = _a.sent();
                    _a.label = 2;
                case 2: return [4 /*yield*/, uploadValidator(files)];
                case 3:
                    allowed = _a.sent();
                    if (!allowed || (multipleFilesCheckResult === null || multipleFilesCheckResult === void 0 ? void 0 : multipleFilesCheckResult.includes(false))) {
                        e.target.value = '';
                        return [2 /*return*/];
                    }
                    setTimeout(function () {
                        // @ts-ignore
                        setFiles(function (prev) { return __spreadArray(__spreadArray([], (prev || []), true), newFiles, true); });
                    }, 0);
                    return [2 /*return*/];
            }
        });
    }); }, [files, fileRef]);
    // console.log('tst here', files, fileRef)
    var _e = useUppyLoader(files, fileRef, onUploadComplete, time), uppy = _e[0], data = _e[1];
    var onRemoveImage = useCallback(function (id, name) {
        // @ts-ignore
        if (fileRef === null || fileRef === void 0 ? void 0 : fileRef.current) {
            fileRef.current.value = '';
            uppy.removeFile(id);
        }
        setTime(Date.now());
        setTimeout(function () {
            setFiles(files === null || files === void 0 ? void 0 : files.filter(function (file) { return (file === null || file === void 0 ? void 0 : file.name) !== name; }));
        }, 0);
    }, [files, fileRef, uppy]);
    useEffect(function () {
        if (!isEditing) {
            setSortedData([]);
            setFiles([]);
        }
    }, [update, isEditing]);
    useEffect(function () {
        setSortedData(data);
    }, [data]);
    useEffect(function () {
        var convertImagesToFiles = function (data) { return __awaiter(void 0, void 0, void 0, function () {
            var dataTransfer, _i, data_1, imageData, response, blob, file, error_1, event_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dataTransfer = new DataTransfer();
                        _i = 0, data_1 = data;
                        _a.label = 1;
                    case 1:
                        if (!(_i < data_1.length)) return [3 /*break*/, 7];
                        imageData = data_1[_i];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        return [4 /*yield*/, fetch("".concat(Endpoints.files, "/").concat(imageData.url), {
                                method: 'GET',
                                mode: 'cors',
                            })];
                    case 3:
                        response = _a.sent();
                        return [4 /*yield*/, response.blob()];
                    case 4:
                        blob = _a.sent();
                        file = new File([blob], "".concat(imageData.url, ".jpg"), {
                            type: 'image/jpeg',
                            lastModified: new Date().getTime(),
                        });
                        dataTransfer.items.add(file);
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435 ".concat(imageData.fileId, ":"), error_1);
                        return [3 /*break*/, 6];
                    case 6:
                        _i++;
                        return [3 /*break*/, 1];
                    case 7:
                        if (fileRef.current) {
                            fileRef.current.files = dataTransfer.files;
                            event_1 = new Event('change', { bubbles: true });
                            fileRef.current.dispatchEvent(event_1);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        if (isEditing && !!(attachments === null || attachments === void 0 ? void 0 : attachments.length)) {
            var convertAttachments = attachments === null || attachments === void 0 ? void 0 : attachments.map(function (i) { var _a; return (_a = i === null || i === void 0 ? void 0 : i.files) === null || _a === void 0 ? void 0 : _a[0]; });
            convertImagesToFiles(convertAttachments);
        }
    }, [attachments, isEditing]);
    var onSortEnd = useCallback(function (_a) {
        var oldIndex = _a.oldIndex, newIndex = _a.newIndex;
        setSortedData(function (prevData) {
            var updatedData = Array.from(prevData);
            var movedItem = updatedData.splice(oldIndex, 1)[0];
            updatedData.splice(newIndex, 0, movedItem);
            return updatedData;
        });
    }, []);
    var getHelperDimensions = useCallback(function (_a) {
        var node = _a.node;
        return ({
            width: node.offsetWidth,
            height: node.offsetHeight,
        });
    }, []);
    return (React.createElement(ImagesContentContainer, { className: "content-container" },
        !(sortedData === null || sortedData === void 0 ? void 0 : sortedData.length) && !!(files === null || files === void 0 ? void 0 : files.length) && (React.createElement(ListWrapper, null,
            React.createElement(NegativeMarginContainer, null, files.map(function (file) { return React.createElement(Loader, null); })))),
        !!(sortedData === null || sortedData === void 0 ? void 0 : sortedData.length) && (React.createElement(SortableList, { items: sortedData, onSortEnd: onSortEnd, onRemove: onRemoveImage, useWindowAsScrollContainer: true, helperContainer: function () { return document.querySelector('.sortable-container'); }, axis: "xy", getHelperDimensions: getHelperDimensions, useDragHandle: true })),
        React.createElement(ButtonWrapper, null, !(sortedData === null || sortedData === void 0 ? void 0 : sortedData.length) && (React.createElement(React.Fragment, null,
            React.createElement(ImageAddButton, null,
                React.createElement("span", null, t('chat.post.images'))),
            React.createElement("input", { type: 'file', accept: 'image/jpeg, image/gif, image/png', multiple: true, 
                /*@ts-ignore*/
                ref: fileRef, onChange: function (e) {
                    onAddImage(e);
                } }))))));
};
export default memo(ImageArrayComponent);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=ImageArrayComponent.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { FC, memo, useCallback, useEffect, useRef, useState } from "react";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import { Endpoints, TFile } from "@brg/api";
import styled from "styled-components";
import { Colors, FlexBox } from "@brg/ui";
import useLocalization from "../../../../../hooks/useLocalization";
import { MoveIcon } from "../../assets/MoveIcon";
import { DeleteCloseIcon } from "../../assets/DeleteCloseIcon";
import { ImageAddButton, ImagesContentContainer } from "../../styles";
import { SpinnerIcon } from "../../assets/Spinner";
import useUploadValidator, { uploadValidator } from "../../../../../hooks/useUploadValidator";
import { useUppyLoader } from "./uppyLoader";
var SortableImageWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 140px;\n  margin: 0 8px 8px 0;\n  flex-shrink: 0;\n  position: relative;\n  max-width: fit-content;\n  img {\n    user-select: none;\n    object-fit: contain;\n  }\n"], ["\n  height: 140px;\n  margin: 0 8px 8px 0;\n  flex-shrink: 0;\n  position: relative;\n  max-width: fit-content;\n  img {\n    user-select: none;\n    object-fit: contain;\n  }\n"])));
var NegativeMarginContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 -8px -8px 0;\n  position: relative;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 -8px -8px 0;\n  position: relative;\n"])));
var ListWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: 8px;\n  position: relative;\n"], ["\n  margin-bottom: 8px;\n  position: relative;\n"])));
var ButtonWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  position: relative;\n\n  input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    z-index: 1;\n    opacity: 0;\n    cursor: pointer;\n  }\n"], ["\n  width: 100%;\n  position: relative;\n\n  input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    z-index: 1;\n    opacity: 0;\n    cursor: pointer;\n  }\n"])));
var ControlButtonsWrapper = styled(FlexBox)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  justify-content: space-between;\n  padding: 4px;\n"], ["\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  justify-content: space-between;\n  padding: 4px;\n"])));
var Content = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 100%;\n  min-height: 48px;\n  max-width: 610px;\n"], ["\n  width: 100%;\n  min-height: 48px;\n  max-width: 610px;\n"])));
var LoaderWrapper = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  height: 140px;\n  width: 140px;\n  border: 1px solid ", ";\n  margin: 0 8px 8px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  height: 140px;\n  width: 140px;\n  border: 1px solid ", ";\n  margin: 0 8px 8px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), Colors.galBlack10);
var Loader = function () {
    return (React.createElement(LoaderWrapper, null,
        React.createElement(SpinnerIcon, null)));
};
var DragHandle = SortableHandle(function () { return (React.createElement("span", { tabIndex: 0 },
    React.createElement(MoveIcon, { size: "small" }))); });
var SortableItem = SortableElement(function (_a) {
    var value = _a.value, onRemove = _a.onRemove;
    return (React.createElement(SortableImageWrapper, null,
        React.createElement(ControlButtonsWrapper, null,
            React.createElement(DragHandle, null),
            React.createElement(DeleteCloseIcon, { size: "small", onClick: function (e) {
                    onRemove(value.id, value.name);
                } })),
        React.createElement("img", { src: value.src, style: { width: '100%', height: '100%' /*, objectFit: 'cover' */ }, draggable: "false" })));
});
var SortableList = SortableContainer(function (_a) {
    var items = _a.items, onRemove = _a.onRemove;
    return (React.createElement(ListWrapper, { className: "sortable-container" },
        React.createElement(NegativeMarginContainer, null, items.map(function (value, index) { return (React.createElement(SortableItem, { key: value.id, index: index, value: value, onRemove: onRemove })); }))));
});
var ImageArrayComponent = function (_a) {
    var onChange = _a.onChange, isEditing = _a.isEditing, attachments = _a.attachments, update = _a.update;
    var t = useLocalization().t;
    var _b = useState([]), sortedData = _b[0], setSortedData = _b[1];
    var _c = useState(Date.now()), time = _c[0], setTime = _c[1];
    var _d = useState([]), files = _d[0], setFiles = _d[1];
    // const validator = useUploadValidator();
    var fileRef = useRef();
    useEffect(function () {
        onChange(sortedData === null || sortedData === void 0 ? void 0 : sortedData.map(function (data) {
            var _a;
            return {
                files: [{ fileId: (_a = data === null || data === void 0 ? void 0 : data.id) !== null && _a !== void 0 ? _a : '' }]
            };
        }));
    }, [sortedData]);
    var onUploadComplete = useCallback(function (uploadComplete) {
        if (uploadComplete) {
            setFiles([]);
        }
    }, []);
    var onAddImage = useCallback(function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var newFiles, multipleFilesCheckResult, allowed;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newFiles = Array.from(e.target.files);
                    // @ts-ignore
                    if (fileRef === null || fileRef === void 0 ? void 0 : fileRef.current)
                        fileRef.current.value = '';
                    setTime(Date.now());
                    multipleFilesCheckResult = [];
                    if (!((newFiles === null || newFiles === void 0 ? void 0 : newFiles.length) > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all(newFiles.map(function (img) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, uploadValidator([img])];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); }))];
                case 1:
                    multipleFilesCheckResult = _a.sent();
                    _a.label = 2;
                case 2: return [4 /*yield*/, uploadValidator(files)];
                case 3:
                    allowed = _a.sent();
                    if (!allowed || (multipleFilesCheckResult === null || multipleFilesCheckResult === void 0 ? void 0 : multipleFilesCheckResult.includes(false))) {
                        e.target.value = '';
                        return [2 /*return*/];
                    }
                    setTimeout(function () {
                        // @ts-ignore
                        setFiles(function (prev) { return __spreadArray(__spreadArray([], (prev || []), true), newFiles, true); });
                    }, 0);
                    return [2 /*return*/];
            }
        });
    }); }, [files, fileRef]);
    // console.log('tst here', files, fileRef)
    var _e = useUppyLoader(files, fileRef, onUploadComplete, time), uppy = _e[0], data = _e[1];
    var onRemoveImage = useCallback(function (id, name) {
        // @ts-ignore
        if (fileRef === null || fileRef === void 0 ? void 0 : fileRef.current) {
            fileRef.current.value = '';
            uppy.removeFile(id);
        }
        setTime(Date.now());
        setTimeout(function () {
            setFiles(files === null || files === void 0 ? void 0 : files.filter(function (file) { return (file === null || file === void 0 ? void 0 : file.name) !== name; }));
        }, 0);
    }, [files, fileRef, uppy]);
    useEffect(function () {
        if (!isEditing) {
            setSortedData([]);
            setFiles([]);
        }
    }, [update, isEditing]);
    useEffect(function () {
        setSortedData(data);
    }, [data]);
    useEffect(function () {
        var convertImagesToFiles = function (data) { return __awaiter(void 0, void 0, void 0, function () {
            var dataTransfer, _i, data_1, imageData, response, blob, file, error_1, event_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dataTransfer = new DataTransfer();
                        _i = 0, data_1 = data;
                        _a.label = 1;
                    case 1:
                        if (!(_i < data_1.length)) return [3 /*break*/, 7];
                        imageData = data_1[_i];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        return [4 /*yield*/, fetch("".concat(Endpoints.files, "/").concat(imageData.url), {
                                method: 'GET',
                                mode: 'cors',
                            })];
                    case 3:
                        response = _a.sent();
                        return [4 /*yield*/, response.blob()];
                    case 4:
                        blob = _a.sent();
                        file = new File([blob], "".concat(imageData.url, ".jpg"), {
                            type: 'image/jpeg',
                            lastModified: new Date().getTime(),
                        });
                        dataTransfer.items.add(file);
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435 ".concat(imageData.fileId, ":"), error_1);
                        return [3 /*break*/, 6];
                    case 6:
                        _i++;
                        return [3 /*break*/, 1];
                    case 7:
                        if (fileRef.current) {
                            fileRef.current.files = dataTransfer.files;
                            event_1 = new Event('change', { bubbles: true });
                            fileRef.current.dispatchEvent(event_1);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        if (isEditing && !!(attachments === null || attachments === void 0 ? void 0 : attachments.length)) {
            var convertAttachments = attachments === null || attachments === void 0 ? void 0 : attachments.map(function (i) { var _a; return (_a = i === null || i === void 0 ? void 0 : i.files) === null || _a === void 0 ? void 0 : _a[0]; });
            convertImagesToFiles(convertAttachments);
        }
    }, [attachments, isEditing]);
    var onSortEnd = useCallback(function (_a) {
        var oldIndex = _a.oldIndex, newIndex = _a.newIndex;
        setSortedData(function (prevData) {
            var updatedData = Array.from(prevData);
            var movedItem = updatedData.splice(oldIndex, 1)[0];
            updatedData.splice(newIndex, 0, movedItem);
            return updatedData;
        });
    }, []);
    var getHelperDimensions = useCallback(function (_a) {
        var node = _a.node;
        return ({
            width: node.offsetWidth,
            height: node.offsetHeight,
        });
    }, []);
    return (React.createElement(ImagesContentContainer, { className: "content-container" },
        !(sortedData === null || sortedData === void 0 ? void 0 : sortedData.length) && !!(files === null || files === void 0 ? void 0 : files.length) && (React.createElement(ListWrapper, null,
            React.createElement(NegativeMarginContainer, null, files.map(function (file) { return React.createElement(Loader, null); })))),
        !!(sortedData === null || sortedData === void 0 ? void 0 : sortedData.length) && (React.createElement(SortableList, { items: sortedData, onSortEnd: onSortEnd, onRemove: onRemoveImage, useWindowAsScrollContainer: true, helperContainer: function () { return document.querySelector('.sortable-container'); }, axis: "xy", getHelperDimensions: getHelperDimensions, useDragHandle: true })),
        React.createElement(ButtonWrapper, null, !(sortedData === null || sortedData === void 0 ? void 0 : sortedData.length) && (React.createElement(React.Fragment, null,
            React.createElement(ImageAddButton, null,
                React.createElement("span", null, t('chat.post.images'))),
            React.createElement("input", { type: 'file', accept: 'image/jpeg, image/gif, image/png', multiple: true, 
                /*@ts-ignore*/
                ref: fileRef, onChange: function (e) {
                    onAddImage(e);
                } }))))));
};
export default memo(ImageArrayComponent);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=ImageArrayComponent.js.map